import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ContractTerminationReason  {
    _originalTypeClassName = "zERP.BO.ContractTerminationReason";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ContractTerminationReason.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Name = null;
this.IsSystem = false;
this.SystemReason = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
IsSystem:any;
SystemReason:any;

static GetClassName(): any{return "ContractTerminationReason";
}
static SystemReasonToCode(sysReason: any): any{switch (sysReason) {case Domain.ContractTerminationReasonSystem.VoluntaryResignation:
{
return "111";}
default:
{
return "0";}
}
}
static SystemReasonToDescription(sysReason: any): any{switch (sysReason) {case Domain.ContractTerminationReasonSystem.VoluntaryResignation:
{
return "Οικειoθελής Αποχώρηση";}
default:
{
return "";}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}